import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { OrganizationService } from '@aid/core/services/organization.service';
import { SubscriptionStatus } from '@aid/subscriptions/types/enums';

@Injectable({
  providedIn: 'root'
})
export class OrganizationNotSuspendedGuard {
  constructor(
    private router: Router,
    private organizationService: OrganizationService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    const organization = this.organizationService.requireOrganization();
    if (
      organization.subscriptionStatus !== SubscriptionStatus.CANCELED &&
      !organization.suspended
    ) {
      this.router.navigate([
        this.organizationService.requireOrganization().slug
      ]);
      return false;
    }

    return true;
  }
}
